import {TextToImageConfig, TextUtilsService} from '../services/textUtils.service';
import {AutoScaleSprite} from './AutoScaleSprite';

declare let THREE: any;

export class Label extends AutoScaleSprite {

  private textConfig: TextToImageConfig;
  private cameraWorldPosition;

  constructor(config: { width: number, height: number, name?: string }, textConfig?: TextToImageConfig) {
    super(config.width, config.height);
    this.cameraWorldPosition = new THREE.Vector3();
    this.name = config.name || 'label';
    this.textConfig = textConfig;
  }

  updateText(text: string) {
    const image = TextUtilsService.textToImage(text, this.textConfig);
    if (!this.material.map) {
      this.material.map = new THREE.Texture(image);
    } else {
      this.material.map.image = image;
    }
    this.material.map.needsUpdate = true;
    this.material.needsUpdate = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/Label.ts